import { render, staticRenderFns } from "./ExcelFileUploader.vue?vue&type=template&id=03dc5160&scoped=true"
import script from "./ExcelFileUploader.vue?vue&type=script&lang=js"
export * from "./ExcelFileUploader.vue?vue&type=script&lang=js"
import style0 from "./ExcelFileUploader.vue?vue&type=style&index=0&id=03dc5160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dc5160",
  null
  
)

export default component.exports